module.exports = __webpack_public_path__ + "static/media/etherscan.e99bf2b6.svg";